export const LIB_VERSION = '1.302.0'; // autogenerated
